export default __webpack_public_path__ + "static/media/UploadIconss.7fc15715.svg";